import {createAction, props} from '@ngrx/store';
import {
  ResearchPaperCreateDTO,
  ResearchPaperDTO,
  ResearchPaperManuelScreeningDTO,
  ScreeningResultDTO
} from '../../dto/research-paper';
import {ScreeningProcessDTO} from '../../dto/screening-process';
import {ScreeningRunSettings} from '../../models/screening-settings';


export const clearPaperStore = createAction(
  '[ResearchPaper] Clear Store',
  props<{ projectId: number }>()
);

export const startPaperResearch = createAction(
  '[ResearchPaper] Start Research',
  props<{ projectId: number }>()
);
export const paperResearchFailure = createAction(
  '[ResearchPaper] Research Failure',
  props<{ projectId: number; error: any }>()
);
export const startPaperResearchComplete = createAction(
  '[ResearchPaper] Start Research Complete',
  props<{ projectId: number; papers: ResearchPaperDTO[] }>()
);


export const startPaperScreening = createAction(
  '[ResearchPaper] Start Screening',
  props<{
    projectId: number,
    screeningRunSettings?: ScreeningRunSettings
  }>()
);
export const watchPaperScreening = createAction(
  '[ResearchPaper] Watch Screening',
  props<{ projectId: number }>()
);
export const paperScreeningFailure = createAction(
  '[ResearchPaper] Screening Failure',
  props<{ projectId: number; error: any }>()
);
export const startPaperScreeningComplete = createAction(
  '[ResearchPaper] Start Screening Complete',
  props<{ projectId: number }>()
);


export const startPaperScreeningOnePaper = createAction(
  '[ResearchPaper] Start ScreeningOnePaper',
  props<{ projectId: number, paperId: number }>()
);
export const paperScreeningFailureOnePaper = createAction(
  '[ResearchPaper] Screening FailureOnePaper',
  props<{ projectId: number; error: any, paperId: number }>()
);
export const startPaperScreeningCompleteOnePaper = createAction(
  '[ResearchPaper] Start Screening Complete',
  props<{ projectId: number, paperId: number }>()
);


export const loadResearchPapers = createAction(
  '[ResearchPaper] Load ResearchPapers',
  props<{ projectId: number }>()
);
export const loadResearchPapersSuccess = createAction(
  '[ResearchPaper] Load ResearchPapers Success',
  props<{ projectId: number; papers: ResearchPaperDTO[] }>()
);
export const loadResearchPapersFailure = createAction(
  '[ResearchPaper] Load ResearchPapers Failure',
  props<{ projectId: number; error: any }>()
);

export const updateScreeningResearchPaper = createAction(
  '[ResearchPaper] update screening result ResearchPaper',
  props<{
    projectId: number;
    runId: number;
    paperId: number;
    screeningOne: boolean;
    screeningResult: ScreeningResultDTO
  }>()
);

export const createResearchPaper = createAction(
  '[ResearchPaper] Create ResearchPaper',
  props<{ projectId: number; paper: ResearchPaperCreateDTO, file?: File }>()
);
export const createResearchBulkPaper = createAction(
  '[ResearchPaper] Create bulk csv ResearchPaper',
  props<{ projectId: number; pdfs?: File[], csv: File }>()
);
export const createResearchPaperSuccess = createAction(
  '[ResearchPaper] Create ResearchPaper Success',
  props<{ projectId: number; paper: ResearchPaperDTO }>()
);
export const createResearchBulkPaperSuccess = createAction(
  '[ResearchPaper] Create bulk csv ResearchPaper Success',
  props<{ projectId: number; papers: ResearchPaperDTO[] }>()
);
export const createResearchPaperFailure = createAction(
  '[ResearchPaper] Create ResearchPaper Failure',
  props<{ projectId: number; error: any }>()
);

export const deleteResearchPaper = createAction(
  '[ResearchPaper] Delete ResearchPaper',
  props<{ projectId: number; id: number }>()
);
export const deleteResearchPaperSuccess = createAction(
  '[ResearchPaper] Delete ResearchPaper Success',
  props<{ projectId: number; id: number }>()
);
export const deleteResearchPaperFailure = createAction(
  '[ResearchPaper] Delete ResearchPaper Failure',
  props<{ projectId: number; error: any }>()
);

export const deleteAllResearchPaper = createAction(
  '[ResearchPaper] Delete All ResearchPaper',
  props<{ projectId: number; }>()
);
export const deleteAllResearchPaperSuccess = createAction(
  '[ResearchPaper] Delete All ResearchPaper Success',
  props<{ projectId: number; }>()
);
export const deleteAllResearchPaperFailure = createAction(
  '[ResearchPaper] Delete All ResearchPaper Failure',
  props<{ projectId: number; error: any }>()
);


export const retrieveResearchPaper = createAction(
  '[ResearchPaper] Retrieve ResearchPaper',
  props<{ projectId: number; id: number }>()
);
export const retrieveResearchPaperSuccess = createAction(
  '[ResearchPaper] Retrieve ResearchPaper Success',
  props<{ projectId: number; paper: ResearchPaperDTO }>()
);
export const retrieveResearchPaperFailure = createAction(
  '[ResearchPaper] Retrieve ResearchPaper Failure',
  props<{ projectId: number; error: any }>()
);

export const updateResearchPaper = createAction(
  '[ResearchPaper] Update ResearchPaper',
  props<{ projectId: number; id: number; paper: ResearchPaperDTO }>()
);
export const uploadResearchPaperPDF = createAction(
  '[ResearchPaper] Update ResearchPaper PDF',
  props<{ projectId: number; id: number; file: File }>()
);
export const updateResearchPaperSuccess = createAction(
  '[ResearchPaper] Update ResearchPaper Success',
  props<{ projectId: number; paper: ResearchPaperDTO }>()
);
export const updateResearchPaperFailure = createAction(
  '[ResearchPaper] Update ResearchPaper Failure',
  props<{ projectId: number; error: any }>()
);


export const updateManuelScreeningResearchPaper = createAction(
  '[ResearchPaper] Update manuel screening ResearchPaper',
  props<{ projectId: number; paperId: number; processId: number; result: ResearchPaperManuelScreeningDTO }>()
);

export const createManuelScreeningResearchPaper = createAction(
  '[ResearchPaper] Create manuel screening ResearchPaper',
  props<{ projectId: number; paperId: number; result: ResearchPaperManuelScreeningDTO }>()
);
export const createManuelScreeningResearchPaperSuccess = createAction(
  '[ResearchPaper] Create manuel screening ResearchPaper Success',
  props<{ projectId: number; paperId: number; screening: ScreeningProcessDTO }>()
);

export const checkScreeningRunningStart = createAction(
  '[Screening] Check Running Start',
  props<{ projectId: number }>()
);

export const screeningNotRunning = createAction(
  '[Screening] Check Running Success/Fail &  Not Running'
);

export const stopScreeningStart = createAction(
  '[Screening] Stop Screening Start',
  props<{ projectId: number }>()
);

export const deleteScreeningRun = createAction(
  '[Screening] Delete Screening run',
  props<{ projectId: number; processId: number }>()
);

export const stopScreeningSuccess = createAction('[Screening] Stop Screening Success');
export const stopScreeningFailure = createAction(
  '[Screening] Stop Screening Failure',
  props<{ error: string }>()
);
